import { render, staticRenderFns } from "./program-card.vue?vue&type=template&id=406fa788&scoped=true"
import script from "./program-card.vue?vue&type=script&lang=js"
export * from "./program-card.vue?vue&type=script&lang=js"
import style0 from "./program-card.vue?vue&type=style&index=0&id=406fa788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fa788",
  null
  
)

export default component.exports